// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3q6nz","sendOtp":"AuthorizeToLogin_sendOtp__rzyMN"};